"use client";

import type { ComponentType, SVGProps } from "react";

import { Checkbox } from "@/components/ui/Checkbox";

type CookieOptionProps = {
  checked: boolean;
  description: string;
  id: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  onCheckedChange: (checked: boolean) => void;
};

export function CookieOption({
  checked,
  description,
  id,
  icon: Icon,
  onCheckedChange,
}: CookieOptionProps) {
  return (
    <div className="flex gap-3 rounded-lg border border-border/70 bg-background p-3">
      <Checkbox
        id={id}
        checked={checked}
        className="mt-0.5"
        onCheckedChange={(nextChecked) => onCheckedChange(nextChecked === true)}
      />
      <Icon aria-hidden="true" className="size-5 shrink-0 text-foreground" />
      <label className="text-sm leading-5 text-foreground" htmlFor={id}>
        {description}
      </label>
    </div>
  );
}
